Ext.define('SA.view.scatterplot.ScatterPlotLegend', {
    alias: 'widget.scatter-plot-legend',
    extend: 'SA.view.SimpleContainer',

    bubbleEvents: [
        'change:lineOfBestFitEnabled',
        'change:pointColor',
        'change:pointRadius',
        'change:title',
        'change:xAttribute',
        'change:yAttribute'
    ],

    cls: 'sa-scatter-plot-legend sa-legend sa-legend-dark',
    style: {zIndex: SA.ZIndexes.forLegend()},

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-legend-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-legend-header-title',
                    html: 'LEGEND'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-scatter-plot-legend-body',
            itemId: 'body',

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-scatter-plot-legend-content',
                    itemId: 'defaultModeContent',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-default-mode-label',
                            html: 'Chart Title',
                            itemId: 'titleDefaultModeLabel'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-value-label',
                            itemId: 'titleValueLabel',
                            tpl: '{.:htmlEncode}'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-default-mode-label',
                            html: 'x-axis'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-value-label',
                            itemId: 'xAttributeValueLabel',
                            tpl: '{.:htmlEncode}'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-default-mode-label',
                            html: 'y-axis'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-value-label',
                            itemId: 'yAttributeValueLabel',
                            tpl: '{.:htmlEncode}'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-default-mode-label',
                            html: 'Correlation'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-value-label',
                            itemId: 'correlationValueLabel',
                            tpl: '{.:htmlEncode}'
                        }, {
                            xtype: 'component',
                            cls: 'sa-legend-warning-msg',
                            html: 'Scatter Plots can display a maximum of 10,000 locations (points). There are more than 10,000 matching locations, so we are displaying a random selection of 10,000 locations.',
                            itemId: 'maximumLocationsReachedWarning'
                        }
                    ]
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-scatter-plot-legend-content',
                    itemId: 'editModeContent',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-edit-mode-label',
                            html: 'Chart Title'
                        }, {
                            xtype: 'sa-text-field',
                            itemId: 'titleTextField',
                            maxLength: SA.data.ScatterPlotView.getMaxTitleLength()
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-edit-mode-label',
                            html: 'x-axis'
                        }, {
                            xtype: 'combo-button',
                            itemId: 'xAttributeButton',
                            textTpl: '{name}, {year}',
                            valueField: 'attribute'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-edit-mode-label',
                            html: 'y-axis'
                        }, {
                            xtype: 'combo-button',
                            itemId: 'yAttributeButton',
                            textTpl: '{name}, {year}',
                            valueField: 'attribute'
                        }, {
                            xtype: 'component',
                            cls: 'sa-scatter-plot-legend-edit-mode-label',
                            html: 'Point Size and Color'
                        }, {
                            xtype: 'simple-container',
                            cls: 'sa-scatter-plot-legend-row',

                            items: [
                                {
                                    xtype: 'combo-button',
                                    itemId: 'pointRadiusButton',
                                    items: [1, 2, 3, 4, 5],
                                    width: 87
                                }, {
                                    xtype: 'color-button',
                                    itemId: 'pointColorButton',
                                    width: 86
                                }
                            ]
                        }, {
                            xtype: 'simple-container',
                            cls: 'sa-scatter-plot-legend-row',
                            margin: '5 0 5 0',

                            items: [
                                {
                                    xtype: 'component',
                                    cls: 'sa-scatter-plot-legend-edit-mode-label',
                                    html: 'Line of Best Fit: '
                                }, {
                                    xtype: 'sa-toggle-switch',
                                    itemId: 'lineOfBestFitEnabledSwitch'
                                }
                            ]
                        }
                    ]
                }
            ]
        }, {
            xtype: 'sa-button',
            itemId: 'editButton',
            ui: 'legend'
        }
    ],

    initComponent() {
        this.callParent();

        this.editMode = this.editMode || false;

        this.body = this.down('#body');

        this.defaultModeContent = this.down('#defaultModeContent');
        this.editModeContent = this.down('#editModeContent');

        this.editButton = this.down('#editButton');

        this.correlationValueLabel = this.down('#correlationValueLabel');

        this.lineOfBestFitEnabledSwitch = this.down('#lineOfBestFitEnabledSwitch');

        this.maximumLocationsReachedWarning = this.down('#maximumLocationsReachedWarning');

        this.pointColorButton = this.down('#pointColorButton');
        this.pointRadiusButton = this.down('#pointRadiusButton');

        this.titleDefaultModeLabel = this.down('#titleDefaultModeLabel');
        this.titleTextField = this.down('#titleTextField');
        this.titleValueLabel = this.down('#titleValueLabel');

        this.xAttributeButton = this.down('#xAttributeButton');
        this.xAttributeValueLabel = this.down('#xAttributeValueLabel');
        this.yAttributeButton = this.down('#yAttributeButton');
        this.yAttributeValueLabel = this.down('#yAttributeValueLabel');
    },

    initEvents() {
        this.callParent();

        this.getEl().on('mousedown', this.onDragStart, this);

        this.editButton.on('click', this.toggleEditMode, this);

        this.lineOfBestFitEnabledSwitch.on('change', this.onLineOfBestFitEnabledSwitchChange, this);

        this.pointColorButton.on('change', this.onPointColorButtonChange, this);
        this.pointRadiusButton.on('change', this.onPointRadiusButtonChange, this);

        this.titleTextField.on('blur', this.onTitleTextFieldBlur, this);

        this.xAttributeButton.on('change', this.onXAttributeButtonChange, this);
        this.yAttributeButton.on('change', this.onYAttributeButtonChange, this);

        this.mon(this.up(), 'resize', this.onAncestorResize, this);
    },

    onAncestorResize() {
        var el = this.getEl(),
            offsetParent = Ext.get(el.dom.offsetParent),
            right = offsetParent.getX() + offsetParent.getWidth() - el.getX() - el.getWidth(),
            top = el.getY() - offsetParent.getY();

        el.setStyle({
            right: `${Ext.Number.constrain(right, 0, offsetParent.getWidth() - el.getWidth())}px`,
            top: `${Ext.Number.constrain(top, 0, offsetParent.getHeight() - el.getHeight())}px`
        });
    },

    onDragStart(ev) {
        if (['.sa-button', '.sa-text-field', '.sa-toggle-switch'].some(sel => ev.getTarget(sel))) {
            return;
        }

        var el = this.getEl(),
            offsetRight = el.getX() + el.getWidth() - ev.getX(),
            offsetTop = ev.getY() - el.getY();

        ev.preventDefault();

        this.mon(Ext.getDoc(), 'mousemove', onDragMove, this, {preventDefault: true});
        this.mon(Ext.getDoc(), 'mouseup', onDragStop, this, {single: true});

        this.addCls('sa-scatter-plot-legend-dragging');

        function onDragMove(ev) {
            var offsetParent = Ext.get(el.dom.offsetParent),
                right = offsetParent.getX() + offsetParent.getWidth() - ev.getX() - offsetRight,
                top = ev.getY() - offsetParent.getY() - offsetTop;

            el.setStyle({
                right: `${Ext.Number.constrain(right, 0, offsetParent.getWidth() - el.getWidth())}px`,
                top: `${Ext.Number.constrain(top, 0, offsetParent.getHeight() - el.getHeight())}px`
            });
        }

        function onDragStop() {
            this.mun(Ext.getDoc(), 'mousemove', onDragMove, this);

            this.removeCls('sa-scatter-plot-legend-dragging');
        }
    },

    onLineOfBestFitEnabledSwitchChange(_, enabled) {
        this.fireEvent('change:lineOfBestFitEnabled', enabled);
    },

    onPointColorButtonChange(_, color) {
        this.fireEvent('change:pointColor', color);
    },

    onPointRadiusButtonChange(_, radius) {
        this.fireEvent('change:pointRadius', radius);
    },

    onTitleTextFieldBlur(titleTextField) {
        this.fireEvent('change:title', titleTextField.getValue());
    },

    onXAttributeButtonChange(_, attributeId) {
        this.fireEvent('change:xAttribute', attributeId);
    },

    onYAttributeButtonChange(_, attributeId) {
        this.fireEvent('change:yAttribute', attributeId);
    },

    refresh({data, isLineOfBestFitEnabled, isPartial, pointColor, pointRadius, projectAttributes, title, xAttribute, yAttribute}) {
        var {calculateCorrelation, formatCorrelation} = SA.view.scatterplot.ScatterPlot,
            projectAttributeItems = SA.data.AttributesCache.get(projectAttributes),
            correlation = calculateCorrelation(data, xAttribute, yAttribute);

        this.correlationValueLabel.update(formatCorrelation(correlation));

        this.lineOfBestFitEnabledSwitch.setChecked(isLineOfBestFitEnabled);

        this.maximumLocationsReachedWarning.setVisible(isPartial);

        this.pointColorButton.setColor(pointColor);
        this.pointRadiusButton.setValue(pointRadius);

        this.xAttributeButton.setItems(projectAttributeItems);
        this.xAttributeButton.setValue(xAttribute);
        this.xAttributeValueLabel.update(SA.data.AttributesCache.getLabel(xAttribute));

        this.yAttributeButton.setItems(projectAttributeItems);
        this.yAttributeButton.setValue(yAttribute);
        this.yAttributeValueLabel.update(SA.data.AttributesCache.getLabel(yAttribute));

        this.refreshTitle(title); 
    },

    refreshLayout() {
        var hasTitle = !!this.titleTextField.getValue();

        this.defaultModeContent.ifCls(this.editMode, 'sa-scatter-plot-legend-content-hidden');
        this.editModeContent.ifCls(!this.editMode, 'sa-scatter-plot-legend-content-hidden');

        this.titleDefaultModeLabel.setVisible(hasTitle);
        this.titleValueLabel.setVisible(hasTitle);

        this.editButton.setText(this.editMode ? 'Done' : 'Edit');

        this.body.setHeight(this.editMode ? this.editModeContent.getHeight() : this.defaultModeContent.getHeight());
    },

    refreshTitle(title) {
        this.titleTextField.setValue(title);
        this.titleValueLabel.update(title);

        this.refreshLayout();
    },

    toggleEditMode() {
        this.editMode = !this.editMode;

        this.refreshLayout();
    }
});